import React, { useContext, useRef, useEffect, useState } from 'react';

import { Context } from '@store/store';

import { 
  UpdateModal, 
  UpdateModalBody, 
  UpdateModalFooter, 
  UpdateModalInput, 
  UpdateModalBtnWhite, 
  UpdateModalBtn, 
} from './editor-cookie.styles';

const EditorCookie = ({ cookie }) => {
  const [state, dispatch] = useContext(Context);
  const [cookieModal, setCookieModal] = useState(true);
  const wrapperRef = useRef();
  useOnClickOutside(wrapperRef, () => {
    dispatch({ type: 'SHOW_EDITOR_COOKIE', payload: false});
  });

  return (
    state.isEditorCookieOpened ? (
    <UpdateModal>
        <UpdateModalBody ref={wrapperRef}>
          <h2>Пользовательское соглашение</h2>
          <p>Для продолжения работы вы должны принять <a href="https://new.nlrs.ru/about/user-agreement" target="_blank">пользовательское соглашение</a>. 
          Нажимая кнопку «Подтвердить», вы соглашаетесь с его условиями</p>
          <UpdateModalFooter>
            <UpdateModalBtnWhite onClick={() => {
              dispatch({ type: 'SHOW_EDITOR_COOKIE', payload: false});
            }}>Закрыть</UpdateModalBtnWhite>
            <UpdateModalBtn onClick={() => { 
              cookie()
              dispatch({ type: 'TOGGLE_EDITOR_MODAL' });
            }}>Подтвердить</UpdateModalBtn>
          </UpdateModalFooter>
        </UpdateModalBody>
    </UpdateModal> ) : null
  );
}

function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}

export default EditorCookie;